import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import FormBuilder from "../../components/Common/Reusables/FormBuilder";
import { PageFields } from "../../constants/FieldConst/PageConst";
import { Button, ButtonDropdown, Card, CardBody, Col, Container, DropdownItem, DropdownMenu, DropdownToggle, Row } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import { ERROR, PERMISSION_ADD, PERMISSION_EDIT, PERMISSION_VIEW, SAVE, SAVE_AND_CLOSE, SAVE_AND_NEW, TAB_PAGE, SWITCH, SELECT } from '../../components/Common/Const';
import { addPageToDB, updateSavedState } from '../../Features/Tabs/pageSlice';
import axiosInstance from "../../Features/axios";
import SpinnerModel from "../../components/Model/SpinnerModel";
import { checkPermission } from '../../components/Common/Reusables/reusableMethods';
import { updateToastData } from "../../Features/toasterSlice";
import { isEmpty } from 'lodash';

const AddPage = () => {
  const pageName = TAB_PAGE
  const finalizeRef = useRef(null);
  const [drp_up, setDrp_up] = useState(false);
  const [initialEditData, setInitialEditData] = useState(undefined);
  const [currentSaveAction, setCurrentSaveAction] = useState(undefined);
  const { isSaved, isLoading } = useSelector(state => state.tabsData.page);
  const permissionObj = useSelector(state => state.auth?.tabPermissionList);
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const location = useLocation();
  const [pageId, setPageId] = useState(location.state?.pageId || "0");
  const [masterData, setMasterData] = useState({});

  useEffect(() => {
    if (pageId !== "0") {
      fetchData(pageId);
    }
  }, [pageId]);

  useEffect(() => {
    if (!isEmpty(permissionObj) && !checkPermission(permissionObj, pageName, PERMISSION_VIEW)) {
      navigate("/dashboard")
    }
    fetchMasterData()
  }, [permissionObj]);

  useEffect(() => {
    if (isSaved) {
      dispatch(updateSavedState(undefined))
      if (currentSaveAction === SAVE_AND_CLOSE) {
        navigate("/Page")
      }
      else if (currentSaveAction === SAVE_AND_NEW) {
        setInitialEditData({})
        setPageId("0")
        finalizeRef.current.resetForm()
      }
      setCurrentSaveAction(undefined)
    }
  }, [isSaved]);

  const fetchData = async (pageId) => {
    await axiosInstance.post('/admin/page/byId', { pageId })
      .then((response) => {
        setInitialEditData(response?.result);
      }).catch((error) => {
        dispatch(updateToastData({ data: error?.message, title: error?.title, type: ERROR }));
      });
  };

  const fetchMasterData = async () => {
    axiosInstance.post('/admin/page/pageFormateList', {})
      .then((response) => {
        setMasterData((prevData) => ({
          ...prevData, "pageFormatId":
            response?.result?.map(item => {
              return { label: item.pageFormatName, value: item.pageFormatId }
            })
        }));
      }).catch((error) => {
        dispatch(updateToastData({ data: error?.message, title: error?.title, type: ERROR }));
      });
  };

  const handleSaveClick = async (saveAction) => {
    const dataToSave = finalizeRef.current.finalizeData()
    if (dataToSave) {
      const extraData = {
        pageId: pageId,
        // isStatic: dataToSave?.isStatic || false,
        // isDefault: dataToSave?.isDefault || false,
        pageFormatId: dataToSave?.isLink ? null : dataToSave?.pageFormatId,
      }
      const completeData = {};
      PageFields.forEach((field) => {
        const { name, type } = field;
        if (!name) return;
  
        let value = dataToSave[name];
        if (value === "" || value === undefined) {
          value = null;
        }
  
        if (type === SELECT) {
          completeData[name] = value ?? 0;
        } else if (type === SWITCH) {
          completeData[name] = value ?? false;
        } else {
          completeData[name] = value ?? null;
        }
      });
      
      dispatch(addPageToDB({ ...completeData, ...extraData }))
      setCurrentSaveAction(saveAction);
    }
  };
  function generateAlias() {
    const finalizeData = finalizeRef.current.getCurrentFormData();
    const { pageName } = finalizeData;
    const autoGeneratedAlias = "/" + pageName.toLowerCase().replace(/[^\w\s]/g, '').replace(/\s+/g, '-');
    finalizeRef.current.updateFormFromParent({ "alias": autoGeneratedAlias })
  }
  const handleBackClick = () => {
    navigate("/Page");
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col xs={12} md={8} lg={9}>
              <h3 className="modal-header-title">Page</h3>
            </Col>
            <Card>
              <CardBody>
                {isLoading && <SpinnerModel />}
                <Row>
                  <Col className='mb-3' xs={12} md={{ span: 4, offset: 8 }} lg={{ span: 3, offset: 9 }}>
                    <button className="btn btn-danger mx-1" onClick={handleBackClick}>Back</button>
                    <ButtonDropdown
                      direction="down"
                      isOpen={drp_up}
                      toggle={() => setDrp_up(!drp_up)}
                    >
                      <Button
                        disabled={
                          !(checkPermission(permissionObj, pageName, PERMISSION_ADD) ||
                            checkPermission(permissionObj, pageName, PERMISSION_EDIT))}
                        id="caret" color="primary" onClick={() => { handleSaveClick(SAVE_AND_CLOSE) }}>
                        Save & Close
                      </Button>
                      <DropdownToggle caret color="primary">
                        <i className="mdi mdi-chevron-down" />
                      </DropdownToggle>
                      <DropdownMenu>
                        {checkPermission(permissionObj, pageName, PERMISSION_EDIT)
                          && <DropdownItem onClick={() => { handleSaveClick(SAVE) }}>Save</DropdownItem>
                        }
                        {checkPermission(permissionObj, pageName, PERMISSION_ADD)
                          && <DropdownItem onClick={() => { handleSaveClick(SAVE_AND_NEW) }}>Save & New</DropdownItem>
                        }
                      </DropdownMenu>
                    </ButtonDropdown>
                  </Col>
                </Row>
                <FormBuilder
                  ref={finalizeRef}
                  fields={PageFields}
                  editFormData={initialEditData}
                  masterData={masterData}
                  generateAlias={generateAlias}
                />
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default AddPage;
